/**
 * Maps internal filter keys to readable URL param names and back.
 * Internal key -> URL param name
 */
const KEY_TO_PARAM = {
  weather_suitable: 'wetter',
  price_range: 'preis',
  weitere_filter: 'filter',
  label_slug: 'label',
  activity_class: 'typ',
  // FilterCategory slugs (now German, used directly as URL param names)
  kategorie: 'kategorie',
  jahreszeit: 'jahreszeit',
  region: 'region',
  alter: 'alter',
  dauer: 'dauer',
  tage: 'tage',
};

const PARAM_TO_KEY = Object.fromEntries(Object.entries(KEY_TO_PARAM).map(([k, v]) => [v, k]));

/**
 * Serialize activeFilters object -> URLSearchParams string
 * e.g. { weather_suitable: ['rainy'], duration: ['<2h'] }
 *   -> "wetter=rainy&dauer=%3C2h"
 */
export function filtersToParams(activeFilters) {
  const params = new URLSearchParams();
  Object.entries(activeFilters).forEach(([key, values]) => {
    if (key === 'open_now' || key === 'is_new' || key === 'kindergeburtstag') {
      if (values === true) params.set(key, '1');
      return;
    }
    if (!Array.isArray(values) || values.length === 0) return;
    const paramName = KEY_TO_PARAM[key] || key;
    params.set(paramName, values.join(','));
  });
  return params;
}

/**
 * Parse URLSearchParams -> activeFilters object
 */
export function paramsToFilters(searchString) {
  const params = new URLSearchParams(searchString);
  const filters = {};
  params.forEach((value, paramName) => {
    if (paramName === 'open_now' || paramName === 'is_new' || paramName === 'kindergeburtstag') {
      if (value === '1') filters[paramName] = true;
      return;
    }
    const key = PARAM_TO_KEY[paramName] || paramName;
    filters[key] = value.split(',').filter(Boolean);
  });
  return filters;
}

/**
 * Returns true if any filter has values
 */
export function hasActiveFilters(activeFilters) {
  return activeFilters.open_now === true || activeFilters.is_new === true || activeFilters.kindergeburtstag === true ||
    Object.values(activeFilters).some(v => Array.isArray(v) && v.length > 0);
}